module.exports = __webpack_public_path__ + "img/Group_11889.56bd0a5c.svg";